import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';
import useData from "hooks/useData";
import Loader from "components/ui/Loader/Loader";
import Expandable from "components/ui/Expandable/Expandable";
import Checkbox from "components/form/Checkbox/Checkbox";
import Alert from "components/ui/Alert/Alert";

const Interests = ({ selection, onSelectionUpdated }) => {
  const [loading, setLoading] = useState(true);
  const { getData } = useData();
  const interestsRef = useRef();

  useEffect(
    () => {
      const loadInterests = async () => {
        setLoading(true);
        const { data } = await getData('rest/interests');
        interestsRef.current = data;
        setLoading(false);
      }
      loadInterests();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

  if (loading) {
    return <Loader containerVariant={ 'center' }/>;
  }

  if (!interestsRef.current) {
    return <Alert message={ `De interesses konden niet worden opgehaald, ververs de pagina en probeer het opnieuw.` }/>;
  }

  let categories = [];
  let children = [];
  interestsRef.current.forEach((item) => {
    const parent_id = item.parent[0].target_id;
    if (parent_id) {
      children.push(item);
    } else {
      categories.push(item);
    }
  });

  const handleSelectItem = (updatedId, selected) => {
    let newSelection = [...selection];
    if (selected) {
      newSelection.push(updatedId);
    } else {
      newSelection = selection.map(id => id !== updatedId ? id : null);
    }
    if (onSelectionUpdated) {
      onSelectionUpdated(newSelection);
    }
  }

  return categories.map((category, index) => {
    return (
      <Expandable key={ index } label={ category.name[0].value }>
        {
          children.map(
            (item, index) => {
              if (item.parent[0].target_id === category.tid[0].value) {
                const tid = item.tid[0].value;
                return <Checkbox key={ tid }
                                 id={ tid }
                                 label={ item.name[0].value }
                                 onChange={ (event) => handleSelectItem(tid, event.target.checked) }
                                 checked={ selection.indexOf(tid) !== -1 }>{ item.name[0].value }</Checkbox>;
              } else {
                return null;
              }
            }
          )
        }
      </Expandable>
    );
  });
}

Interests.propTypes = {
  selection: PropTypes.array.isRequired,
  onSelectionUpdated: PropTypes.func.isRequired,
}

export default Interests;
